module.exports = __webpack_public_path__ + "static/img/icon-04.1f4a432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-it-works/icon-04.png
// module id = pkXT
// module chunks = 1